import React from "react";
import PropTypes from "prop-types";
import {
  LinearProgress,
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  ListItemSecondaryAction
} from "@material-ui/core";
import Done from "@material-ui/icons/Done";
import Error from "@material-ui/icons/Error";
import FileUpload from "@material-ui/icons/CloudUpload";

const getIcon = status => {
  switch (status) {
    case "success":
      return <Done />;
    case "pending":
      return <FileUpload />;
    default:
      return <Error />;
  }
};

const FileListCard = props => (
  <Card style={{ maxHeight: props.height, overflow: "auto" }}>
    <CardHeader title="Upload status" />
    <CardContent>
      {props.isFetching ? (
        <LinearProgress />
      ) : (
        <List>
          {props.rawFiles.map(file => {
            const filenameWithExt = file.ext
              ? `${file.name}.${file.ext}`
              : file.name;
            return (
              <ListItem key={file.id} button>
                <ListItemIcon>{getIcon(file.status)}</ListItemIcon>
                <ListItemText
                  primary={filenameWithExt}
                  secondary={file.message}
                  style={{ wordWrap: "break-word" }}
                />
                <ListItemSecondaryAction>
                  <Typography component="span" color="textSecondary">
                    {file.static ? "static" : ""}
                  </Typography>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      )}
    </CardContent>
  </Card>
);

FileListCard.propTypes = {
  height: PropTypes.number,
  rawFiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.string,
      name: PropTypes.string.isRequired,
      message: PropTypes.string,
      static: PropTypes.bool.isRequired,
      ext: PropTypes.string
    })
  ).isRequired,
  isFetching: PropTypes.bool.isRequired
};

FileListCard.defaultProps = {
  height: 300
};

export default FileListCard;
